import {
  GlobalEvents,
  SectionElement,
  Theme,
  defineElement,
  globalOn,
  on,
  onClick,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/sections/common-header/common-header.ts
var CommonHeader = class extends SectionElement {
  constructor() {
    super(...arguments);
    this.isOpenCountry = false;
  }
  handleOpenLinkDrawer(elm) {
    var _a;
    const handle = elm.dataset.linkButton;
    if (handle == null || typeof handle === "undefined")
      return;
    (_a = this.linkDrawers.find((d) => d.key === handle)) == null ? void 0 : _a.open();
  }
  handleOpenChildLinkDrawer(elm) {
    var _a;
    const handle = elm.dataset.childLinkButton;
    if (handle == null || typeof handle === "undefined")
      return;
    (_a = this.childLinkDrawers.find((d) => d.key === handle)) == null ? void 0 : _a.open();
  }
  handleCloseLinkDrawer(elm) {
    var _a;
    const handle = elm.dataset.linkDrawerClose;
    if (handle == null || typeof handle === "undefined")
      return;
    (_a = this.linkDrawers.find((d) => d.key === handle)) == null ? void 0 : _a.close();
  }
  handleCloseChildLinkDrawer(elm) {
    var _a;
    const handle = elm.dataset.childLinkDrawerClose;
    if (handle == null || typeof handle === "undefined")
      return;
    (_a = this.childLinkDrawers.find((d) => d.key === handle)) == null ? void 0 : _a.close();
  }
  showCountryModal() {
    return __async(this, null, function* () {
      if (this.isOpenCountry) {
        void this.closeCountry();
      } else {
        yield this.openCountry();
      }
    });
  }
  openCountry() {
    return __async(this, null, function* () {
      this.countryModal.open();
      this.isOpenCountry = true;
    });
  }
  closeCountry() {
    return __async(this, null, function* () {
      this.countryModal.close();
      this.isOpenCountry = false;
    });
  }
  handleScroll() {
    var _a;
    if (window.scrollY > 40) {
      if (!this.hasAttribute("scrolled")) {
        this.setAttribute("scrolled", "");
        (_a = this.searchPopover) == null ? void 0 : _a.resetInput();
      }
    } else if (window.scrollY < 20) {
      if (this.hasAttribute("scrolled")) {
        this.removeAttribute("scrolled");
      }
    }
  }
  showModal() {
    return __async(this, null, function* () {
      var _a, _b, _c;
      window.scrollTo(0, 0);
      (_b = (_a = this.searchMobile) == null ? void 0 : _a.querySelector("[data-predictive-search]")) == null ? void 0 : _b.focus();
      (_c = this.searchPopover) == null ? void 0 : _c.handleInput();
    });
  }
  handleOpenCart() {
    GlobalEvents.emit("cart:open");
  }
  handleOpenMenu() {
    GlobalEvents.emit("menu:open");
  }
  open() {
    return __async(this, null, function* () {
      this.drawer.open();
    });
  }
  close() {
    return __async(this, null, function* () {
      this.drawer.close();
    });
  }
  handleHoverEnter() {
    return __async(this, null, function* () {
      var _a, _b;
      (_a = this.shopAllCategories) == null ? void 0 : _a.classList.remove("hidden");
      (_b = this.shopAllCategories) == null ? void 0 : _b.handleHoverEnter();
    });
  }
  handleHoverExit() {
    return __async(this, null, function* () {
      var _a, _b;
      (_a = this.shopAllCategories) == null ? void 0 : _a.classList.add("hidden");
      (_b = this.shopAllCategories) == null ? void 0 : _b.handleHoverExit();
    });
  }
  connectedCallback() {
    return __async(this, null, function* () {
      this.handleScroll();
      window == null ? void 0 : window.document.addEventListener("scroll", () => this.handleScroll());
      const cartVatExclusive = document.querySelector("[data-cart-vat-exclusive]");
      const cartVatInclusive = document.querySelector("[data-cart-vat-inclusive]");
      document.getElementById("inclvat").addEventListener("change", (e) => __async(this, null, function* () {
        const target = e.target;
        if (target.checked) {
          yield Theme.Cart.updateCartAttributes({ _vat_state: "true" });
          GlobalEvents.emit("cart:updated");
          cartVatExclusive == null ? void 0 : cartVatExclusive.classList.add("!hidden");
          cartVatInclusive == null ? void 0 : cartVatInclusive.classList.remove("!hidden");
        } else {
          yield Theme.Cart.updateCartAttributes({ _vat_state: "false" });
          GlobalEvents.emit("cart:updated");
          cartVatExclusive == null ? void 0 : cartVatExclusive.classList.remove("!hidden");
          cartVatInclusive == null ? void 0 : cartVatInclusive.classList.add("!hidden");
        }
      }));
    });
  }
};
__decorateClass([
  query("[data-menu-drawer]")
], CommonHeader.prototype, "drawer", 2);
__decorateClass([
  query("[search-modal]")
], CommonHeader.prototype, "searchModal", 2);
__decorateClass([
  query("[country-modal]")
], CommonHeader.prototype, "countryModal", 2);
__decorateClass([
  query("[data-search-popover]")
], CommonHeader.prototype, "searchPopover", 2);
__decorateClass([
  query("[data-mobile-search]")
], CommonHeader.prototype, "searchMobile", 2);
__decorateClass([
  queryAll("[data-link-drawer]")
], CommonHeader.prototype, "linkDrawers", 2);
__decorateClass([
  queryAll("[data-child-link-drawer]")
], CommonHeader.prototype, "childLinkDrawers", 2);
__decorateClass([
  onClick("[data-link-button]")
], CommonHeader.prototype, "handleOpenLinkDrawer", 1);
__decorateClass([
  onClick("[data-child-link-button]")
], CommonHeader.prototype, "handleOpenChildLinkDrawer", 1);
__decorateClass([
  onClick("[data-link-drawer-close]")
], CommonHeader.prototype, "handleCloseLinkDrawer", 1);
__decorateClass([
  onClick("[data-child-link-drawer-close]")
], CommonHeader.prototype, "handleCloseChildLinkDrawer", 1);
__decorateClass([
  onClick("[data-country-open]")
], CommonHeader.prototype, "showCountryModal", 1);
__decorateClass([
  onClick("[data-modal-search]")
], CommonHeader.prototype, "showModal", 1);
__decorateClass([
  onClick("[data-open-cart]")
], CommonHeader.prototype, "handleOpenCart", 1);
__decorateClass([
  onClick("[data-open-menu]")
], CommonHeader.prototype, "handleOpenMenu", 1);
__decorateClass([
  query("[data-additional-text]")
], CommonHeader.prototype, "addText", 2);
__decorateClass([
  query("[data-menu-row]")
], CommonHeader.prototype, "menuRow", 2);
__decorateClass([
  query("[data-menu2-row]")
], CommonHeader.prototype, "menuRow2", 2);
__decorateClass([
  query("[data-row-container]")
], CommonHeader.prototype, "rowContainer", 2);
__decorateClass([
  query("[data-shop-logo]")
], CommonHeader.prototype, "shopLogo", 2);
__decorateClass([
  query("[data-mobile-text]")
], CommonHeader.prototype, "addTextMobile", 2);
__decorateClass([
  query("[data-menu-row-mega]")
], CommonHeader.prototype, "menuRowMega", 2);
__decorateClass([
  globalOn("menu:open")
], CommonHeader.prototype, "open", 1);
__decorateClass([
  globalOn("menu:close"),
  onClick("[data-menu-close]")
], CommonHeader.prototype, "close", 1);
__decorateClass([
  query("shop-all-categories")
], CommonHeader.prototype, "shopAllCategories", 2);
__decorateClass([
  on("mouseenter", "[data-open-all]")
], CommonHeader.prototype, "handleHoverEnter", 1);
__decorateClass([
  on("mouseleave", "[data-open-all]")
], CommonHeader.prototype, "handleHoverExit", 1);
CommonHeader = __decorateClass([
  defineElement("common-header")
], CommonHeader);
export {
  CommonHeader
};
